import PresortDemo from "../components/table/DataTable";
import { useEffect, useRef, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import "./page.css"
import { useGetBalanceQuery, useCreateOrUpdateBalanceMutation, useAddBalenceMutation } from "../store/api/balanceAPI";
import { balanceColumn } from "../metadata/bonus";
import { SpeedDial } from "primereact/speeddial";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { useActionsHook } from "../hooks/useActionsHook";
import { Toast } from 'primereact/toast';
import { useParams } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";
import { t } from "i18next";



function Bonus() {
	const { id } = useParams()
	const { data, error, isLoading } = useGetBalanceQuery();
	const toast = useRef(null);
	const [visibleDialog, setVisibleDialog] = useState(false);
	const balanceColumnTr = useTranslatedColumns(balanceColumn);
	const [columns, setColumns] = useState([])
	const [createOrUpdateBonus] = useCreateOrUpdateBalanceMutation();
	const [addBalance] = useAddBalenceMutation();
	const actions = useActionsHook([
		{
			onClick: (e, data) => {
				setFormData(data); // очистить форму
				setVisibleDialog(true); // открыть диалог
				setBalance({
					totalBalance: data.balance
				})
			},
			icon: "pi pi-plus"
		},
		{
			onClick: (...params) => {

			},
			icon: "pi pi-trash"
		}
	])
	const items = [
		{
			label: 'React Website',
			icon: 'pi pi-external-link',
			command: () => {
				// window.location.href = 'https://react.dev/';
			}
		}
	];

	const [formData, setFormData] = useState({

	});

	const [balance, setBalance] = useState({

	});

	const [visibleLeft, setVisibleLeft] = useState({
		visible: false,
		data: null
	});

	function toggleSidebar(bool, data) {
		setFormData(data)
		setVisibleLeft(state => {
			return {
				visible: bool,
				data: data
			}
		})
	}

	const onBlur = (e, attr, value) => {
		setFormData(state => {
			return {
				...state,
				[attr]: value
			}
		});
	}



	return (<>
		<Toast ref={toast} />
		<p
			style={{
				paddingLeft: 12,
				fontSize: 18,
				fontWeight: 600,
			}}
		>
			{t("balance")}
		</p>
		<PresortDemo
			isLoading={isLoading}
			data={data}
			column={balanceColumnTr}
			toggleSidebar={toggleSidebar}
			deleteHandler={(row, field) => {
				console.log(row, field);
			}}
			actions={actions}
		/>
		<SpeedDial
			model={items}
			radius={120}
			type="quarter-circle"
			onClick={() => {
				toggleSidebar(true, {});
			}}
			direction="up-left"
			style={{ right: 35, bottom: 35 }} />
		<Sidebar visible={visibleLeft.visible} position="right" onHide={() => { toggleSidebar(false) }} style={{ width: "50vw" }}>
			<div className="user-sidebar">
				<div className="user-sidebar-edit">
					{
						balanceColumnTr.filter((i) => i.editor).map(el => {
							return (
								<div>
									<Editor {...el} onBlur={onBlur} data={formData} />
								</div>
							)
						})
					}
					<div></div>
					<MyButton label="Сохранить" onClick={async () => {
						await createOrUpdateBonus(formData);
						toast.current.show({ severity: 'info', summary: 'Success', detail: t("successSaved"), life: 3000 });
						toggleSidebar(false)
					}} />
				</div>
			</div>
		</Sidebar>
		<Dialog
			header={t("addBalance")}
			visible={visibleDialog}
			style={{ width: '50vw' }}
			onHide={() => setVisibleDialog(false)}
			modal
		><p
			style={{
				paddingLeft: 12,
				fontSize: 18,
				fontWeight: 600,
			}}
		>
				{balance.totalBalance}
			</p>
			<div className="user-sidebar-edit">
				<div >
					<Editor type={2} label={t("balance")} attr="balance" onBlur={(e, attr, value) => {
						setBalance(state => {
							return {
								totalBalance: value + formData.balance
							}
						})
					}} data={balance} />
				</div>
				{/* <MyButton
					label="Сохранить"
					onClick={async () => {
						await addBalance({
							guid: formData.guid,
							balance: balance.totalBalance,
							addedalance: balance.balance
						});
						toast.current.show({ severity: 'success', summary: 'Успешно', detail: 'Бонус добавлен', life: 3000 });
						setVisibleDialog(false);
					}}
				/> */}
			</div>
			<SpeedDial
				model={items}
				radius={120}
				type="quarter-circle"
				onClick={async () => {
					await addBalance({
						guid: formData.guid,
						balance: balance.totalBalance,
						addedalance: balance.balance
					});
					toast.current.show({ severity: 'success', summary: 'Success', detail: t("bonusAdded"), life: 3000 });
					setVisibleDialog(false);
				}}
				direction="up-left"
				style={{ right: 35, bottom: 35 }} />
		</Dialog>
	</>);
}

export default Bonus;